import { CompanyProfile } from 'projects/workspace/src/app/administration/models/company-profile.model';

export function getPermissions(companyProfile: CompanyProfile): any[] {
  const permissions: any[] = [
    {
      module: 'wholesale',
      locked: 'selected',
      view: 'availableForSelect',
      edit: 'availableForSelect',
      manage: 'availableForSelect',
    },
    {
      module: 'ecommerce',
      locked: 'selected',
      view: 'availableForSelect',
      edit: 'availableForSelect',
      manage: 'availableForSelect',
      enabled: companyProfile.subscriptionManagement.subscriptionPermissions.ECOMMERCE_INTEGRATIONS
    },
    {
      module: 'services',
      locked: 'selected',
      view: 'availableForSelect',
      edit: 'availableForSelect',
      manage: 'availableForSelect',
      enabled: companyProfile.subscriptionManagement.subscriptionPermissions.TIME_TRACKING
    },
    {
      module: 'accounting',
      locked: 'selected',
      view: 'availableForSelect',
      edit: 'availableForSelect',
      manage: 'availableForSelect'
    },
    {
      module: 'warehouse',
      locked: 'selected',
      view: 'availableForSelect',
      edit: 'availableForSelect',
      manage: 'availableForSelect',
      enabled: companyProfile.subscriptionManagement.subscriptionPermissions.OUTGOING_DELIVERIES
    },
    {
      module: 'products',
      locked: 'selected',
      view: 'availableForSelect',
      edit: 'availableForSelect',
      manage: 'availableForSelect'
    },
    {
      module: 'partners',
      locked: 'selected',
      view: 'availableForSelect',
      edit: 'availableForSelect',
      manage: 'availableForSelect'
    },
    {
      module: 'team',
      locked: 'selected',
      view: 'availableForSelect',
      edit: 'availableForSelect',
      manage: 'availableForSelect'
    },
    {
      module: 'administration',
      locked: 'selected',
      view: 'availableForSelect',
      edit: 'availableForSelect',
      manage: 'availableForSelect'
    },
    // {
    //   module: 'analytics',
    //   locked: 'selected',
    //   view: 'availableForSelect',
    //   edit: 'availableForSelect',
    //   manage: 'availableForSelect'
    // },
    // {
    //   module: 'retail',
    //   locked: 'selected',
    //   view: 'availableForSelect',
    //   edit: 'availableForSelect',
    //   manage: 'availableForSelect'
    // },
  ];

  return permissions
    .filter(itm => !itm.hasOwnProperty('enabled') || itm.enabled);
}
